import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@material-ui/core"
import { Form, Formik } from "formik"
import { useContext } from "react"
import { useQueryClient } from "react-query"
import { useHistory } from "react-router"
import * as Yup from "yup"
import CounterHeader from "~/components/Common/CounterHeader"
import LoaderButton from "~/components/LoaderButton/index.jsx"
import AppContext from "~/contexts/App"
import serialize from "~/store/serialize"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const CreateCertificationDialog = () => {
  const queryClient = useQueryClient()
  //reused dialog for create course, create lesson, create cliente and create instructor
  const classes = useStyles()
  const history = useHistory()
  const { dialogs, closeDialog, openSnackBar, authContext } =
    useContext(AppContext)
  const thisDialog = dialogs?.["createCertificationDialog"] || {}
  const { open = false, data } = thisDialog
  let createFuncMutation = thisDialog?.data?.create

  const schema = Yup.object().shape({
    name: Yup.string()
      .required(`Please enter a name`)
      .max(50, "Name must be less than 50 characters"),
  })

  const handleClose = () => {
    closeDialog("createCertificationDialog", false)
  }

  const onSubmit = (values, actions) => {
    createFuncMutation
      .mutateAsync(values)
      .then((res) => {
        serialize("certification", res.data).then((serializedData) => {
          queryClient.setQueryData("certifications", (oldData) => {
            return [...oldData, serializedData]
          })
        })
        history.push(`certifications/${res.data.id}/content`)
        openSnackBar({
          message: `${"Certification Created"}`,
        })
      })
      .catch((err) => {
        openSnackBar({
          message: "There was an error creating a certification",
        })
      })
      .finally(() => {
        handleClose()
      })
  }

  return (
    <Dialog classes={{ paperWidthSm: classes.dialogMinHeight }} open={open}>
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <Typography variant="h2" className={classes.title}>
          New Certification
        </Typography>
        <Typography color="primary" variant="subtitle2">
          Create a new certification
        </Typography>
      </DialogTitle>
      <Formik
        initialValues={{ name: "" }}
        onSubmit={onSubmit}
        validationSchema={schema}
      >
        {({
          handleChange,
          values,
          errors,
          touched,
          handleBlur,
          isSubmitting,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <DialogContent className={classes.dialogContent}>
              <CounterHeader
                title="Certification Name"
                value={values.name}
                max={50}
              />
              <TextField
                type="text"
                name="name"
                id="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={
                  <span>{touched.name && errors.name ? errors.name : " "}</span>
                }
                /* eslint-disable-next-line */
                autoFocus
                InputProps={{
                  classes: {
                    root: classes.inputBackgroundColor,
                  },
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter" && e.target.value.length > 0) {
                    onSubmit({ name: e.target.value })
                    e.preventDefault()
                  }
                }}
                error={!!touched.name && !!errors.name}
                variant="filled"
                size="small"
                fullWidth
                FormHelperTextProps={{
                  className: classes.formHelperText,
                }}
              />
            </DialogContent>
            <DialogActions>
              <Box margin="16px">
                <Button
                  onClick={handleClose}
                  style={{ height: "40px" }}
                  className="mr-2"
                >
                  Cancel
                </Button>
                <LoaderButton
                  type="submit"
                  classoverrides={{
                    wrapper: classes.button,
                    button: {
                      root: classes.buttonRoot,
                    },
                  }}
                  variant="contained"
                  color="secondary"
                  working={isSubmitting}
                  size="small"
                >
                  add
                </LoaderButton>
              </Box>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}

CreateCertificationDialog.propTypes = {}

export default CreateCertificationDialog
